import React from 'react'
import { SettingsConsumer, SettingsProvider } from './@core/context/settingsContext'
import ThemeComponent from './@core/theme/ThemeComponent'
import ReactHotToast from './@core/styles/libs/react-hot-toast'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import UserLayout from './layouts/UserLayout'

import Notifications from 'src/pages/notifications';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import LoginPage from "./pages/login";
import RegisterMultiSteps from "./pages/signup";
import ForgotPassword from "./pages/forgot-password";
import ConfirmAccount from "./pages/confirm-account";
import RedirectHomePage from "./pages/home/home";
import DocumentationPage from "./pages/documentation/index";
import Index from "./pages";
import SolicitationSummaryWrapper from "./pages/solicitation-view/SolicitationSummaryWrapper";
import CompanyContextLayoutRoute from "./pages/solicitation-new/CompanyContextLayoutRoute";
import NewSolicitationStepper from "./pages/solicitation-new";
import SolicitationInterchange from "./pages/solicitation-view/interchange/SolicitationInterchange";
import Home from "./pages/solicitations";
import AccountData from "./pages/account";
import ContactsPage from "./pages/contacts/ContactsPage";
import {AuthTokenFields, SessionManager} from '@itec/session_manager';
import {HttpAuth} from "./http/user/httpAuth";
import {authTokenStorage} from "./utils/localStorage/authTokenStorage";
import {logoutHelper} from "./utils/helpers/logoutHelper";
import {HttpAxiosRequest} from "./http/httpAxiosBase";
import LoginByTokenPageLoader from './pages/login/LoginByTokenPageLoader'
import RecoverPassword from './pages/recover-password'

function App() {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <SettingsProvider>
                <SettingsConsumer>
                    {/* TODO: Se podría convertir esto a useContext, para mantener consistencia. */}
                    {({ settings }) => {
                        return (
                            <ThemeComponent settings={settings}>
                                <Router>
                                    <SessionManager
                                        onRefreshToken={HttpAuth.refreshToken}
                                        onGetTokenExpirationTime={() => authTokenStorage.getExpirationTime()}
                                        onSaveToken={(token) => {
                                            authTokenStorage.save(token)
                                            HttpAxiosRequest.refreshToken(token[AuthTokenFields.AuthToken])
                                        }}
                                        onSessionExpired={logoutHelper}
                                        sessionTimeoutTolerance={5}
                                        includeRoutes={['/']}
                                        excludeRoutes={['/login', '/login-jwt', '/register', 'forgot-password', '/confirm-account', '/recover-password']}
                                    />
                                    <Routes>
                                        <Route path={"/"} element={<RedirectHomePage />} />
                                        <Route path={'/login'} element={<LoginPage />} />
                                        <Route path={"/login-jwt"} element={<LoginByTokenPageLoader />} />
                                        <Route path={'/register'} element={<RegisterMultiSteps />} />
                                        <Route path={'/forgot-password'} element={<ForgotPassword />} />
                                        <Route path={'/confirm-account'} element={<ConfirmAccount />} />
                                        <Route path={"/recover-password/:guid"} element={<RecoverPassword />} />

                                        <Route element={<CompanyContextLayoutRoute />}>
                                            <Route element={<UserLayout />}>
                                                <Route path={"/home"} element={<Index/>}/>
                                                <Route path={'/solicitudes'}>
                                                    <Route path={''} element={<Home />} />
                                                    <Route path={'nueva-solicitud'} element={<NewSolicitationStepper />} />
                                                    {/* <Route path={':id/historia'} element={<SolicitudHistoria />} /> */}
                                                    <Route path={':id/intercambio'} element={<SolicitationInterchange />} />
                                                    <Route path={':id'} element={<SolicitationSummaryWrapper />} />
                                                </Route>
                                                <Route path={'/mis-datos'} element={<AccountData/>}/>
                                                <Route path={'/comerciales'} element={<ContactsPage />}/>
                                                <Route path={'/ayuda'} element={<></>}/>
                                                <Route path={'/documentacion'} element={<DocumentationPage />} />
                                                <Route path={'/notificaciones'} element={<Notifications />} />
                                            </Route>
                                        </Route>
                                    </Routes>
                                </Router>
                                <ReactHotToast>
                                    <Toaster position={settings.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
                                </ReactHotToast>
                            </ThemeComponent>
                        )
                    }}
                </SettingsConsumer>
            </SettingsProvider>
        </LocalizationProvider>
    )
}

export default App
